// 设置全局常量
let wincourseBaseUrl = window._CONFIG.VUE_APP_API_WINCOURSE_BASE_URL
    ? window._CONFIG.VUE_APP_API_WINCOURSE_BASE_URL
    : process.env.VUE_APP_API_WINCOURSE_BASE_URL
let wincourseWebBaseUrl = window._CONFIG.VUE_APP_API_WINCOURSE_WEB_URL
    ? window._CONFIG.VUE_APP_API_WINCOURSE_WEB_URL
    : process.env.VUE_APP_API_WINCOURSE_WEB_URL

window._CONFIG['domianURL'] = wincourseBaseUrl
window._CONFIG['domianWebURL'] = wincourseWebBaseUrl
